import { type FC } from "react";
import { isEmpty } from "lodash-es";
import { twMerge } from "tailwind-merge";
import { LabelOptions, type GeoInfo } from "./openRegionCascaderModal";
import { Icon } from "@/assets/icon/Icon";
import { Pressable } from "@/comps/Pressable";

export const Selector: FC<{
  value: GeoInfo[];
  onClick: (index: number) => void;
}> = ({ value, onClick }) => {
  if (isEmpty(value)) {
    return null;
  }
  return (
    <div className="border-b-color-border-1 border-b">
      {LabelOptions.map((v, index) => {
        if (value[index] || value[index - 1]) {
          const hasValue = Boolean(value[index]);
          return (
            <Pressable
              key={v}
              className="active:bg-color-fill-2 flex h-11 items-center px-6"
              onPress={() => onClick(index)}
            >
              <div className="relative flex-1 pl-8">
                <div
                  className={
                    hasValue ? "text-color-text-1" : "text-color-primary"
                  }
                >
                  {value[index]?.name || v}
                </div>
                <div
                  className={twMerge(
                    "size-[9px] rounded-full absolute left-0 top-1/2 -translate-y-1/2",
                    hasValue ? "bg-color-primary" : "bg-color-border-2",
                  )}
                />
                {hasValue && index < LabelOptions.length - 1 ? (
                  <div className="bg-color-primary absolute left-1 top-1/2 h-11 w-px" />
                ) : null}
              </div>
              <Icon type="arrow" className="shrink-0" />
            </Pressable>
          );
        }
        return null;
      })}
    </div>
  );
};
